import { INVALID_CODES } from "@/core/validation";
import { ScenarioConstants, MessageHistoryCustom, FaqCategory, ValidationResult } from "@/model";
import { isUrl } from "@/util/stringUtil";


export const isValidTitle = (value: string): ValidationResult => {
    if (!value) {
        return { isValid: false, code: INVALID_CODES.REQUIRED };
    }
    return { isValid: true };
};

export const isValidWebhookUrl = (value?: string): ValidationResult => {
    if (!value) {
        return { isValid: true };
    }
    if (!isUrl(value)) {
        return { isValid: false, code: INVALID_CODES.INVALID_FORMAT };
    }
    return { isValid: true };
};

export const isValidConstants = (constants?: ScenarioConstants): ValidationResult => {
    if (!constants) {
        return { isValid: true };
    }
    if (Object.keys(constants).some(key => !key)) {
        return { isValid: false, code: INVALID_CODES.REQUIRED };
    }
    return { isValid: true };
};

export const isValidMessageHistoryCustom = (list?: MessageHistoryCustom[]): ValidationResult => {
    if (!list) {
        return { isValid: true };
    }
    if (list.some(item => !item.key || !item.label)) {
        return { isValid: false, code: INVALID_CODES.REQUIRED };
    }
    if (
        new Set(list.map(item => item.key)).size !== list.length
        || new Set(list.map(item => item.label)).size !== list.length
    ) {
        return { isValid: false, code: INVALID_CODES.DUPLICATE };
    }
    return { isValid: true };
};

export const isValidContextExcludeKeys = (keys?: string[]): ValidationResult => {
    if (!keys) {
        return { isValid: true };
    }
    if (keys.some(key => !key.trim())) {
        return { isValid: false, code: INVALID_CODES.INVALID_FORMAT };
    }
    if (new Set(keys).size !== keys.length) {
        return { isValid: false, code: INVALID_CODES.DUPLICATE };
    }
    return { isValid: true };
};

export const isValidFaq = (faq?: FaqCategory[]): ValidationResult => {
    if (!faq) {
        return { isValid: true };
    }
    if (faq.some(category => !category.category)) {
        return { isValid: false, code: INVALID_CODES.REQUIRED };
    }
    if (new Set(faq.map(category => category.category)).size !== faq.length) {
        return { isValid: false, code: INVALID_CODES.DUPLICATE };
    }
    if (faq.some(category => 
        category.qna_list?.some(qna => !qna.question || !qna.answer)
    )) {
        return { isValid: false, code: INVALID_CODES.REQUIRED };
    }
    return { isValid: true };
};
